import e from "./SpecificationExtensions.vue.script.js";
//#region src/specification-extensions/SpecificationExtensions.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=SpecificationExtensions.vue.js.map